var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-card"},[_c('div',{staticClass:"qr-container"},[_c('div',{staticClass:"qr-item"},[_c('img',{staticClass:"qr-img",attrs:{"src":_vm.qrImages[_vm.randomIndex],"alt":_vm.$t('cpts.qrcard.qr')}})])]),_c('p',{staticClass:"qr-text"},[_vm._v(_vm._s(_vm.$t("cpts.qrcard.action")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }